import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import Banner from '../../components/solutions/agriculture/Banner';
import AISolutions from '../../components/solutions/agriculture/AISolutions';
import CaseStudy from '../../components/solutions/agriculture/CaseStudy';
import AgricultureTransformation from '../../components/solutions/agriculture/AgricultureTransformation';
import Advantage from '../../components/solutions/agriculture/Advantage';
import FooterBanner from '../../components/solutions/agriculture/FooterBanner';

const Agriculture = () => {

  return (
    <>
      <SEO
				title="Agriculture & Food Industry Solutions"
				description="Empowering Smarter, Sustainable Farming and Food Systems with Edge AI."
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <Banner />
      <AISolutions />
      <CaseStudy />
      <AgricultureTransformation />
      <Advantage />
      <FooterBanner />
      <FooterOne />
    </>
  )
}

export default Agriculture;